<template>
  <div id="sessionInfo">
    <div class="notification is-info">
      <div v-if="testId === 2">
        <p>Your Id: {{ userId }}</p>
        <p>Note this down so that you can check your results later.</p>
      </div>

      <div v-if="testId === 3">
        <p>உங்கள் ஐடி: {{ userId }}</p>
        <p>இந்த ஐடியை நினைவில் கொள்ளுங்கள், பிறகு உங்கள் முடிவுகளை நீங்கள் பார்க்கலாம்.</p>
      </div>

      <div v-if="testId === 6">
        <p>Your Id: {{ userId }}</p>
        <p>Note this down so that you can check your results later.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sessionInfo',
  data() {
    return {
      userId: this.$temp.sessionCode,
      testId: +this.$temp.testId,
    };
  },
  methods: {},
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/SessionInfo.vue